import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem, pxToRem } from '@archipro-design/aria';

export const FeatureTitle: StyleRule = () => ({
    padding: pxArrayToRem([0, 18]),
    marginBottom: pxToRem(31),
});
